import { useEffect } from "react";
import { CacheProvider } from "@emotion/react";
import CssBaseline from "@mui/joy/CssBaseline";
import { CssVarsProvider } from "@mui/joy/styles";
import { ToastContainer } from "react-toastify";

import createEmotionCache from "./utils/createEmotionCache";
import Router from "./routes/Router";
import { generateTheme } from "./configs/theme";
import { useIsPersian } from "./components/hooks/isPersian";

import "./assets/global.css";
import "react-toastify/dist/ReactToastify.min.css";

const App = () => {
  const isPersian = useIsPersian();
  const dir = isPersian ? "rtl" : "ltr";
  const lang = isPersian ? "fa" : "en";

  useEffect(() => {
    document.body.dir = dir;
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }, [dir, lang]);

  return (
    <CacheProvider value={createEmotionCache()}>
      <CssVarsProvider theme={generateTheme(lang)} defaultMode="dark">
        <CssBaseline />
        <Router />
        <ToastContainer limit={3} autoClose={10000} />
      </CssVarsProvider>
    </CacheProvider>
  );
};

export default App;
